import * as yup from "yup";
import { KeyValueMap } from "../../../redux/slices/appState/models";
import { MANAGE_REVENUE_SPLIT_INLINE_FORM_KEYS } from "./models";

export const ManageRevenueSplitInlineValidationSchema = (
  commonValidationMessages: KeyValueMap,
) =>
  yup.object().shape({
    [MANAGE_REVENUE_SPLIT_INLINE_FORM_KEYS.COUNSELING]: yup
      .string()
      .required(commonValidationMessages.requiredValidation),
  });
